export const convertToMinutes = (timeStamp) => {
    const hours = parseFloat(timeStamp.slice(0,2));
    const minutes = parseFloat(timeStamp.slice(-2));
    return hours*60 + minutes;
}